import { useTranslation } from "react-i18next";
import { HCP_REGISTRIES } from "../../../api/src/shared/domain/hcp-registry";

export function RegistryCoverage({
  registry,
}: {
  registry: keyof typeof HCP_REGISTRIES | "reps";
}) {
  const { t } = useTranslation();
  const scope = {
    rpps: t("RPPS lists registered health professionals in France."),
    npi: t("NPPES lists individual healthcare providers with a US NPI."),
    inami: t(
      "Health Pro has partial coverage of Belgian healthcare professions."
    ),
    big: t(
      "BIG lists 11 regulated Dutch professions, so other professions do not receive a BIG number."
    ),
    stps: t("STPS lists professional authorizations in Denmark."),
    om: t("Ordem dos Médicos lists physicians registered in Portugal."),
    reps: t(
      "REPS shows public Spanish healthcare records, but its coverage is incomplete."
    ),
  } satisfies Record<keyof typeof HCP_REGISTRIES | "reps", string>;
  return <p>{scope[registry]}</p>;
}
